import { useParams } from 'react-router-dom'
import logo from '../../assets/logo.png'
import code_bg from '../../assets/code_bg.png'
import follow from '../../assets/follow.png'
import './index.less'
import { footerMap1 } from '../footer/config.js'
import { CloseOutlined } from '@ant-design/icons';

const Qrcode = () => {
  const { index } = useParams() // 获取 URL 参数

  return (
    <div className="Qrcode">
      <button
        className="Qrcode__backbtn"
        onClick={() => window.history.back()}
        type="button"
        aria-label="关闭"
      >
        <CloseOutlined style={{ fontSize: '6vw', lineHeight: 1 }} />
      </button>
      <img src={logo} className="Qrcode__logo"></img>
      <img src={follow} className="Qrcode__follow"></img>
      {footerMap1[index].qrcode.map((v, i) => {
        return (
          <div key={i} className="Qrcode__list">
            <img className="Qrcode__list__img" src={v.image}></img>
            <div className="Qrcode_list__desc">{v.desc}</div>
          </div>
        )
      })}
    </div>
  )
}

export default Qrcode
